import { Fragment, useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import './Geocode.css';

const Geocode = () => {
	const [ isLoading, setIsLoading ] = useState(true);
	const [ locations, setLocations ] = useState('');
	const [ result, setResult ] = useState('');
	const [ outputArray, setOutputArray ] = useState([]);

	useEffect(
		() => {
			if (outputArray && outputArray.length) {
				//reorder array items to match locations on the left side textarea
				let orderedArray = [];

				var locationsArray = locations.split('\n');

				for (let location of locationsArray) {
					//find item in outpuArray by location
					let outputItem = outputArray.find((x) => x.location.trim() === location.trim());

					if (outputItem) {
						orderedArray.push(outputItem);
					}
				}

				let tempResult = '';
				orderedArray.map((result) => {
					tempResult += result.latlng + '\n';
				});

				setResult(tempResult);
			}
		},
		[ outputArray ]
	);

	const handleSubmit = async (e) => {
		e.preventDefault();

		setResult('');

		if (locations.trim() === '') {
			setIsLoading(false);
			toast.error('Locations field cannot be empty');
			return;
		}

		setIsLoading(true);

		var locationsArray = locations.split('\n');

		for (let location of locationsArray) {
			//await geocodeAddress(locationsArray[i]);
			await geocodeAddress(location);
		}

		setIsLoading(false);
		setOutputArray([]);
	};

	const geocodeAddress = async (location) => {
		const google = window.google;
		const geocoder = new google.maps.Geocoder();

		if (location.trim() !== '' && location.trim().replace('\n', '') !== '') {
			geocoder.geocode(
				{
					address : location
				},
				function(results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						let lat = results[0].geometry.location.lat();
						let lng = results[0].geometry.location.lng();

						setOutputArray((prevState) => [
							...prevState,
							{ location: location, latlng: lat + ',' + lng }
						]);
					}
				}
			);
		}
	};

	return (
		<Fragment>
			<div className="campaign-v-p-report text-start">
				<div className="report-header container d-block">
					<form onSubmit={handleSubmit}>
						<div className="row mb-3">
							<div className="col-lg-6 col-12">
								<label htmlFor="locations" className="form-label">
									Locations:
								</label>
								<textarea
									className="form-control"
									name="locations"
									value={locations}
									rows={20}
									onChange={(e) => setLocations(e.target.value)}
								/>
							</div>
							<div className="col-lg-6 col-12">
								<label htmlFor="result" className="form-label">
									Result:
								</label>
								<textarea className="form-control" name="result" defaultValue={result} rows={20} />
							</div>
						</div>
						<div className="row">
							<div className="col-12">
								<button type="submit" className="btn btn-primary">
									<span>Submit</span>
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</Fragment>
	);
};

export default Geocode;
